import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});
const Schema = Yup.object().shape({
  name: Yup.string().required(),
  type: Yup.string().required(),
  rg: Yup.string(),
  cpf: Yup.string().required(),
  address: Yup.string(),
  neighborhood: Yup.string(),
  number: Yup.string(),
  phone1: Yup.string(),
  phone2: Yup.string(),
  is_ems: Yup.string(),
  is_efs: Yup.string(),
  admission_at: Yup.date('01-01-2021'),
  id_city: Yup.number().required(),
  uf: Yup.string().required(),
});
export default Schema;